import AbstractScene from './AbstractScene.js';

import {Colors} from "../consts/Colors.js"
import {tags} from "../consts/Tags.js"

import RoundedButton from '../prefabs/buttons/RoundedButton.js';
import { Fonts } from '../consts/Fonts.js';

export default class Menu extends AbstractScene {
    constructor() {
        super({
            key: "Menu"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        
        this._preload();
        this.config = this.cache.json.get('config')

        this.questionGroup = this.add.group()
    }

    create(){
        // Background
        var back = this.add.sprite(this.width, 0, 'intro').setOrigin(1, 0)
        // back.setScale(0.45)

        var rect = this.add.sprite(0,0, 'rectIntro').setOrigin(0)
        
        // Ajout line
        var line = this.add.sprite(0, this.height, 'backLine').setOrigin(0, 1)

        // Ajout logo
        var logoABC = this.add.sprite(416, 148, "mqde")

        // Ajout titre
        var Y = 275
        var titreFond = this.add.rexTagText(73, Y-1, this.config.titre, {
            fontSize: "63px",
            fontFamily: Fonts.MassiliaBold,
            align: 'left',
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            wrap: {
                mode: 'word',
                width: 700
            },
            tags: tags
        })
        titreFond.setOrigin(0)

        var Ytxt = 580
        var textElmt = this.add.rexTagText(titreFond.x, Ytxt, this.config.description, {
            fontSize: "35px",
            fontFamily: Fonts.MassiliaRegular,
            align: 'left',
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            tags: tags
        })
        textElmt.setOrigin(0)

        // Ajout bouton
        var button = new RoundedButton(this, this.width/2, 965, { 
            width: 500, 
            height: 100, 
            text: "Démarrer la vidéo", 
            textColor: Colors.Text.Purple, 
            backgroundColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.White,
            hoverBackgroundColor: Colors.Elmt.Purple,
            strokeColor: Colors.Elmt.Purple, 
        })
        button.setClickFunction(()=>{this.nextScene()})
    }
}